export default "__VITE_ASSET__CkjFOYf3__"